import TranslationText from '@components/common/TranslationText'
import { useMyCountry } from '@hooks/useAuth'
import { Titles } from '@interfaces/common'
import React, { FC } from 'react'
import './styles.css'

const formatLocation = (loc) => {
  if (!loc) {
    return null
  } else {
    return loc.split(' ')[0]
  }
}

const Location: FC<{ location: Titles[] }> = ({ location, ...props }) => {
  const { isInternational } = useMyCountry()

  return isInternational ? null
    : (
      <div styleName="loc">
        <i className="icon-location fs10 tw-mr-2" />
        {location.map(
          (loc, idx) =>
            loc?.zhCn ? (
              <TranslationText texts={loc} key={idx}>
                {text => (
                  <span className="text-capitalize product-card-location-unit hide-empty">
                    {formatLocation(text)}
                  </span>
                )}
              </TranslationText>
            ) : null
        )}
      </div>
    )
}

Location.defaultProps = {
  location: [],
}

export default Location
